import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {getAllPaymentMethods} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";

const apiUrl = Config.apiUrl;

const MOVEMENT_TYPE_SUPRIMENTO = 0;
const MOVEMENT_TYPE_SANGRIA = 1;

const CashRegisterMovement = () => {
    const navigate = useNavigate();
    const [, setLoading] = useRecoilState(loadingAtom);
    const searchParams = new URLSearchParams(window.location.search);
    const isSaida = searchParams.get('type') === 'saida';
    const movementType = isSaida ? MOVEMENT_TYPE_SANGRIA : MOVEMENT_TYPE_SUPRIMENTO;

    const [openCashRegister, setOpenCashRegister] = useState(undefined);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethodId, setPaymentMethodId] = useState('');
    const [value, setValue] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        async function loadOpenCashRegister() {
            try {
                setLoading(true);
                const url = apiUrl + '/api/cash-registers/open';
                const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
                setOpenCashRegister(response);
            } catch (error) {
                setOpenCashRegister(null);
            } finally {
                setLoading(false);
            }
        }

        loadOpenCashRegister();
        getAllPaymentMethods().then((p) => setPaymentMethods(p || []));
    }, []);

    const onConfirm = async () => {
        const parsedValue = Number.parseFloat(value);
        if (Number.isNaN(parsedValue) || parsedValue <= 0) {
            alert('Informe um valor válido.');
            return;
        }
        if (!paymentMethodId) {
            alert('Informe a forma de pagamento.');
            return;
        }

        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers/' + openCashRegister.id + '/movements';
            await makeRequest(url, 'POST', {
                'Content-Type': 'application/json',
                'Useruuid': Cookies.get('userUUID'),
            }, JSON.stringify({
                type: movementType,
                paymentMethodId: Number(paymentMethodId),
                value: parsedValue,
                description
            }));
            navigate('/cashregister');
        } catch (error) {
            console.error('Error registering cash movement:', error);
            alert('Não foi possível registrar o lançamento.');
        } finally {
            setLoading(false);
        }
    };

    if (openCashRegister === undefined) {
        return null;
    }

    if (!openCashRegister) {
        return (
            <>
                <div className="header-label">{isSaida ? 'Sangria' : 'Suprimento'}</div>
                <div style={{marginTop: '10px'}}>Nenhum caixa aberto.</div>
                <ActionButtonsManagerView>
                    <button onClick={() => navigate('/cashregister')} className="back-button">Voltar</button>
                </ActionButtonsManagerView>
            </>
        );
    }

    return (
        <>
            <div className="header-label">{isSaida ? 'Sangria (Saída)' : 'Suprimento (Entrada)'}</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Forma de Pagamento:</div>
                <select value={paymentMethodId} onChange={(e) => setPaymentMethodId(e.target.value)}>
                    <option value="">Selecione uma Forma de Pagamento</option>
                    {paymentMethods.map((paymentMethod, i) => (
                        <option key={i} value={paymentMethod.id}>{paymentMethod.name}</option>
                    ))}
                </select>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Valor:</div>
                <input type="number" step="0.01" placeholder="0.00" style={{width: '150px'}}
                       value={value}
                       onChange={(e) => setValue(e.target.value)}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Descrição:</div>
                <input type="text" style={{width: '300px'}}
                       value={description}
                       onChange={(e) => setDescription(e.target.value)}/>
            </div>

            <ActionButtonsManagerView>
                <button onClick={() => navigate('/cashregister')} className="back-button">Cancelar</button>
                <button onClick={onConfirm}>Registrar</button>
            </ActionButtonsManagerView>
        </>
    );
};

export default CashRegisterMovement;
